import './property-editor-location-increase-pattern.js'
import './property-editor-gltf-info.js'
import './property-editor-gltf-fill-targets.js'
import './property-editor-gltf-play-targets.js'
import './property-editor-stocker-location.js'

export default [
  {
    type: 'location-increase-pattern',
    element: 'property-editor-location-increase-pattern'
  },
  {
    type: 'gltf-info',
    element: 'property-editor-gltf-info'
  },
  {
    type: 'gltf-fill-targets',
    element: 'property-editor-gltf-fill-targets'
  },
  {
    type: 'gltf-play-targets',
    element: 'property-editor-gltf-play-targets'
  },
  {
    type: 'stocker-location',
    element: 'property-editor-stocker-location'
  }
]
